import React from 'react';
import { Table, TableHead, TableHeaderCell } from 'src/components';
import { t } from 'i18next';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

interface IDocumentsList {
  children?: React.ReactNode;
  isFromMvpApp?: boolean;
}

export const DocumentsList = ({ children }: IDocumentsList) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <Table role="table">
      {isFromMvpApp ? null : (
        <TableHead role="head">
          <tr role="row">
            <TableHeaderCell>{t('AgreementDocuments')}</TableHeaderCell>
          </tr>
        </TableHead>
      )}
      <tbody role="rowgroup">{children}</tbody>
    </Table>
  );
};
